export const USER_INITIAL_LOCATION = 'location/userInitialLocation';
export const HOTELIER_INITIAL_LOCATION = 'location/hotelierInitialLocation';
